import React, { Component } from 'react';
import { Link } from 'react-router';
import BlitzApi from '../../api/BlitzAPI';
import moment from 'moment';

function EntryScheduleInfo(props) {
  const { entry, platform } = props;
  const entryLink = `/entries/blitz/${entry.id}`;

  let didRun;
  switch (platform) {
    case 'yt':
      didRun = entry.yt_ran
      break;
    case 'fb':
      didRun = entry.fb_id ? 'true' : 'false'
      break;
    case 'twitter':
      didRun = entry.twitter_id ? 'true' : 'false'
      break;
  }
  return(
      <tr style={{
        border: '1px solid'
      }}>
        <td><Link to={entryLink}>{entry.id}</Link></td>
        <td><Link to={entryLink}>{entry.title}</Link></td>
        <td>{moment(entry.publish_date).format('MMM Do[,] YYYY h:mma')}</td>
        <td>{`${didRun}`}</td>
      </tr>
  )
}

function platformToFullName(p) {
  const platforms = {
    'fb': 'Facebook',
    'yt': 'Youtube',
    'twitter': 'Twitter'
  }
  return platforms[p]
}

export default class EntryScheduleBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entries: null,
    }
  }

  componentDidMount() {
    const { platform, alreadyRan } = this.props;
    BlitzApi.getEntries({ 
      [`${platform}_publish`]: true,
      [`${platform}_ran`]: alreadyRan,
    }).then((response) => {
      this.setState({ entries: response.data.data })
    })
  }

  render() {
    const { platform } = this.props;
    const { entries } = this.state;
    console.log(entries)
    return (
      <div style={{ paddingBottom: '40px' }}>
        <h3 style={{ marginBottom: '10px', marginTop: '10px' }}>{platformToFullName(platform)}</h3>
        {entries && entries.length > 0 ?
          <table className="scheduler-table">
            <thead>
              <tr style={{
                border: '1px solid'
              }}>
                <th>ID</th>
                <th>Title</th>
                <th>Scheduled For</th>
                <th>Auto Published?</th>
              </tr>
            </thead>
            <tbody>
              {entries.map(e => <EntryScheduleInfo entry={e} key={e.id} platform={platform} />)}
            </tbody>
          </table> : <div>Nothing scheduled right now</div>}
        </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/cms/entry/EntryScheduleBlock.js